export enum PaymentStatus {
  SUCCESS = 'success',
  PAYMENT_PENDING = 'payment_pending',
  RATE_LIMITED = 'rate_limited',
  GENERIC = 'generic',
  CAPTURED = 'captured',
}

export default PaymentStatus;
